module.exports = __webpack_public_path__ + "media/images/bg_questionnaire_mv_pc-b6620a448a42ba14f60e96771a5fec47.jpg";